import { useSelector } from "react-redux";
import { getEndpointAI } from "../../../abstract/redux/slice/endpointSlice";
import { BaselineHistory } from "../../../themes/icons/BaselineHistory";
import Aside from "./Aside";
import AsideElementAi from "./AsideElementAi";
import AsideElementHistory from "./AsideElementHistory";
import styles from "./AsideRight.module.scss";
import AsideRightControllerIcon from "./AsideRightControllerIcon";
import { GiTomato } from "react-icons/gi";

function AsideRight({ showAside, setShowAside, onAiResponse }) {
  const _endpointAI = useSelector(getEndpointAI);

  const _icons = [<BaselineHistory />];

  if (_endpointAI) {
    _icons.push(<GiTomato />);
  }

  const handleChange = (id) => {
    if (showAside === -1) {
      setShowAside(id);
    } else if (showAside === id) {
      setShowAside(-1);
    } else {
      setShowAside(id);
    }
  };

  return (
    <div className={styles["aside"]}>
      <div className={styles["aside__min"]}>
        <AsideRightControllerIcon display={showAside} onChange={handleChange} icons={_icons} />
      </div>
      <div className={styles["aside__max"]}>
        <Aside showAside={showAside !== -1}>
          {showAside === 0 && <AsideElementHistory />}
          {showAside === 1 && <AsideElementAi onAiResponse={onAiResponse} />}
        </Aside>
      </div>
    </div>
  );
}

export default AsideRight;
